import React from 'react'

function Loader() {
  return (
    // <div className="flex flex-col justify-center items-center h-40">
    //   <div
    //     style={{
    //       border: "8px solid #f3f3f3",
    //       borderTop: "8px solid #7c3aed",
    //       borderRadius: "50%",
    //       width: "64px",
    //       height: "64px",
    //       animation: "spin 1s linear infinite"
    //     }}
    //   ></div>
    //   <span className="mt-4 text-purple-600 text-lg font-semibold">Loading...</span>
    //   <style>{`
    //     @keyframes spin {
    //       0% { transform: rotate(0deg); }
    //       100% { transform: rotate(360deg); }
    //     }
    //   `}</style>
    // </div>
    <div className='loading'>Loading...</div>
  );
}

export default Loader
